import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {Button, Modal} from 'react-bootstrap';
import {Form, Formik} from 'formik';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import * as actions from '../../_redux/invoicesActions';
import DataItemTextarea from '../../../_common/components/DataItemTextarea';
import can from '../../../_common/components/Permissions/can';

const PopupCancelInvoice = ({cellContent}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const {_id, customerEmail, isActual} = cellContent;
  const isEnabled = can('full', 'invoices') && isActual;
  const buttonClassName = `w-100 px-4 py-2 d-flex align-items-center justify-content-between text-nowrap font-size-lg 
  ${isEnabled ? `` : `opacity-30`}`;
  const buttonOpen = intl.formatMessage({
    id: 'invoices-popup-cancelInvoice-title',
    defaultMessage: 'Cancel invoice',
  });
  const message = intl.formatMessage({
    id: 'invoices-popup-cancelInvoice-message',
    defaultMessage: 'Should i cancel the invoice {id}',
  }, {id: _id});
  const labelComments = intl.formatMessage({
    id: 'invoices-popup-cancelInvoice-label-comments',
    defaultMessage: 'Comments'
  });
  const buttonConfirm = intl.formatMessage({
    id: 'invoices-popup-cancelInvoice-button-confirm',
    defaultMessage: 'Yes',
  });
  const buttonCancel = intl.formatMessage({
    id: 'invoices-popup-cancelInvoice-button-cancel',
    defaultMessage: 'No',
  });

  return (
    <>
      <div
        className={buttonClassName}
        onClick={() => {
          if (isEnabled) {
            handleShowModal();
          }
        }}
      >
        {buttonOpen}
        <img
          src={toAbsoluteUrl('/media/svg/Cancel_invoice.svg')}
          alt="icon"
          className={'w-30px h-30px ml-2'}
        />
      </div>
      <Modal
        show={show}
        onHide={handleCloseModal}
      >
        <Modal.Body>
          <Formik
            initialValues={{comments: ''}}
            onSubmit={() => null}
            enableReinitialize={true}
          >
            {({values}) => (
              <Form>
                <div className={'w-100 mb-12 d-flex flex-column align-items-center'}>
                  <div className={'font-weight-bold font-size-lg mb-2'}>
                    {message}
                  </div>
                  <DataItemTextarea
                    fieldId={'comments'}
                    label={labelComments}
                    customLabelStyle={'custom-brand-color'}
                    customContainerStyle={'w-75 mx-auto'}
                  />
                </div>
                <div className="d-flex justify-content-center">
                  <Button
                    className="btn btn-secondary btn-sm col-3 mx-3"
                    onClick={handleCloseModal}
                  >
                    {buttonCancel}
                  </Button>
                  <Button
                    className="btn btn-primary btn-sm col-3 mx-3 custom-send-button"
                    onClick={() => {
                      dispatch(actions.cancelInvoiceAction(_id, values.comments, customerEmail));
                      handleCloseModal();
                    }}
                  >
                    {buttonConfirm}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupCancelInvoice;
